import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
import { API_URL } from "../../../../api";
import axios from "axios";
import { FaArrowLeft, FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { Link, useParams } from "react-router-dom";

function PaidCommissionDetails() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [doctorLists, setDoctorLists] = useState([]);
  const [doctorID, setDoctorID] = useState("");
  const [showDate, setShowDate] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [commissions, setCommissions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [commissionDetails, setCommissionDetails] = useState([]);
  const [appliedStartDate, setAppliedStartDate] = useState("");
  const [appliedEndDate, setAppliedEndDate] = useState("");

  const { id } = useParams();

  const getCommissionDetails = async (startDate = "", endDate = "") => {
    try {
      const res = await api.get(`commission-log/${id}`, {
        params: {
          startDate: startDate ? new Date(startDate).toISOString() : "",
          endDate: endDate ? new Date(endDate).toISOString() : "",
        },
      });

      setCommissionDetails(res.data.data.relatedCommission || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (id) {
      getCommissionDetails();
    }
  }, [id]);

  const filteredCommissions = commissionDetails.filter((row) => {
    if (!row?.createdAt) return false;

    const createdDate = new Date(row.createdAt);

    if (appliedStartDate && new Date(appliedStartDate) > createdDate)
      return false;

    if (appliedEndDate) {
      const end = new Date(appliedEndDate);
      end.setHours(23, 59, 59, 999);
      if (createdDate > end) return false;
    }

    return true;
  });

  const _export = React.useRef(null);

  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };

  const exportData = filteredCommissions.map((row, index) => ({
    no: index + 1,
    voucherCode: row?.relatedTreatmentVoucher?.code || "N/A",
    patientName: row?.relatedAppointment?.relatedPatient?.name || "N/A",
    doctorName: row?.relatedDoctor?.name || "N/A",
    voucherDate: row?.relatedTreatmentVoucher?.createdAt
      ? new Date(row.relatedTreatmentVoucher.createdAt).toLocaleDateString()
      : "N/A",

    treatmentName: row?.treatmentBreakdown[0]?.treatmentId?.name || "-",
    treatmentCount: row?.treatmentBreakdown?.length || 0,
    percent: row?.percent ? `${row.percent}%` : "0%",
    commissionAmount: row?.commissionAmount?.toLocaleString() || "0",
    appointmentAmount: row?.appointmentAmount?.toLocaleString() || "0",
    status: row?.status || "Unpaid",
    createdAt: row?.createdAt
      ? new Date(row.createdAt).toLocaleDateString()
      : "N/A",
  }));

  return (
    <Box p={2}>
      <div className="content-header">
        <div className="container-fluid px-2">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/paid-commission">
                    <i>
                      <FaArrowLeft />
                    </i>
                  </Link>
                </li>
                <li className="breadcrumb-item active mt-1">
                  Paid Commission Details
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item>
          <h4 className="fs-5 py-3 mb-0">Paid Commission</h4>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#1565C0" }}
            onClick={excelExport}
          >
            Export
          </Button>
        </Grid>
      </Grid>
      <Paper sx={{ p: 2, mt: 2, borderRadius: 2 }}>
        <div className="row">
          <div class="col-md-12 card px-3 py-3">
            <div class="table-responsive text-black" id="slimtest2">
              <TableContainer
                component={Paper}
                sx={{ maxWidth: "100%", overflowX: "auto" }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        #
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Voucher Code
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Patient Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Doctor Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Voucher Date
                      </TableCell>

                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Treatment Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Treatment Count
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Percent (%)
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Commission Amount
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Appointment Amount
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Created At
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredCommissions.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          {row?.relatedTreatmentVoucher?.code || "N/A"}
                        </TableCell>

                        <TableCell>
                          {row?.relatedAppointment?.relatedPatient?.name ||
                            "N/A"}
                        </TableCell>

                        <TableCell>
                          {row?.relatedDoctor?.name || "N/A"}
                        </TableCell>

                        <TableCell>
                          {row?.relatedTreatmentVoucher?.createdAt
                            ? new Date(
                                row.relatedTreatmentVoucher.createdAt,
                              ).toLocaleDateString()
                            : "N/A"}
                        </TableCell>

                        <TableCell>
                          {row?.treatmentBreakdown[0]?.treatmentId?.name || "-"}
                        </TableCell>
                        <TableCell>
                          {row?.treatmentBreakdown?.length || 0}
                        </TableCell>
                        <TableCell>
                          {row?.percent ? row.percent + "%" : "0%"}
                        </TableCell>

                        <TableCell>
                          {row?.commissionAmount?.toLocaleString() || "0"}
                        </TableCell>

                        <TableCell>
                          {row?.appointmentAmount?.toLocaleString() || "0"}
                        </TableCell>

                        <TableCell>{row?.status || "Unpaid"}</TableCell>

                        <TableCell>
                          {row?.createdAt
                            ? new Date(row.createdAt).toLocaleDateString()
                            : "N/A"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </Paper>

      <ExcelExport data={exportData} ref={_export}>
        <ExcelExportColumn field="no" title="#" width={50} />
        <ExcelExportColumn field="voucherCode" title="Voucher Code" />
        <ExcelExportColumn field="patientName" title="Patient Name" />
        <ExcelExportColumn field="doctorName" title="Doctor Name" />
        <ExcelExportColumn field="voucherDate" title="Voucher Date" />
        <ExcelExportColumn field="treatmentName" title="Treatment Name" />
        <ExcelExportColumn field="treatmentCount" title="Treatment Count" />
        <ExcelExportColumn field="percent" title="Percent (%)" />
        <ExcelExportColumn field="commissionAmount" title="Commission Amount" />
        <ExcelExportColumn
          field="appointmentAmount"
          title="Appointment Amount"
        />
        <ExcelExportColumn field="status" title="Status" />
        <ExcelExportColumn field="createdAt" title="Created At" />
      </ExcelExport>
    </Box>
  );
}

export default PaidCommissionDetails;
